import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { FormAdd } from '../components/FormAdd';
import styleText from '../../../../shared/components/rbh-text/styles';
import { RBHBox, RBHText } from '../../../../shared/components';
import stylesHead from '../../FoodCategory/styles';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { useDispatch } from 'react-redux';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import styles from '../styles';

export const AddMartCategoryScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 4));
  }, []);

  const pushToMain = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main');
  };

  const pushToMartCategory = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/martcategory');
  };

  const BreadcrumbAddRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-martCategory-toHome'} id={'breadcrumb-martCategory-toHome'} style={styleText.breadCrumbItemLink}
              onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT
                }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-martCategory'} id={'breadcrumb-martCategory'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: pushToMartCategory,
                type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.mart.category.add.martCategory'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumb-martCategory-add'} id={'breadcrumb-martCategory-add'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.mart.category.add.addMartCategory'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      <BreadcrumbAddRender />
      <RBHBox>
        <RBHBox style={stylesHead.header}>
          <RBHText data-testid={'addMartCategory-header'} id={'addMartCategory-header'} style={styleText.headerText}
            text={'main.mart.category.add.header'} />
        </RBHBox>
        <RBHBox style={styles.defaultContent}>
          <FormAdd onSuccessCallback={pushToMartCategory} onCancel={() =>
            dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
              visible: true,
              onOk: pushToMartCategory,
              type: MODAL_TYPE.CONFIRM_EDIT
            }))} />
        </RBHBox>
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
